import { Directive, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { Drawer } from 'primeng/drawer';

@Directive({
  selector: 'p-drawer[drawerEscapeFix]',
  standalone: true
})
export class DrawerEscapeFixDirective {
  @Output() closeRequested = new EventEmitter<void>();

  constructor(private drawer: Drawer) {
    // Disable the built-in ESC handling
    this.drawer.closeOnEscape = false;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    const allDrawers = document.querySelectorAll('.p-drawer-active');
    if (allDrawers.length === 0) return;

    // Find highest z-index drawer
    let maxZIndex = -1;
    let topDrawer: Element | null = null;
    
    allDrawers.forEach(drawer => {
      const zIndex = parseInt((drawer as HTMLElement).style.zIndex) || 0;
      if (zIndex > maxZIndex) {
        maxZIndex = zIndex;
        topDrawer = drawer;
      }
    });

    // Check if our drawer is the top one
    const container = document.querySelector('.p-drawer-active');
    // Compare by checking if this drawer instance's container matches
    if (this.drawer['container'] === topDrawer) {
      this.drawer.close(event);
      event.stopImmediatePropagation();
    }
  }
}